import { TreeNode } from '@components'

import { rootFolder } from '../constants/rootFolder'
import { FolderPathBreadcrumbItem } from '../types/folderPathBreadcrumbItem'

export const generateFolderPath = (
  currentFolderId: string | null,
  treeNodes: TreeNode[] | undefined,
): FolderPathBreadcrumbItem[] => {
  if (!treeNodes) {
    return []
  }

  const rootPath = [rootFolder]
  if (!currentFolderId) {
    return rootPath
  }

  const nodesById = new Map(treeNodes.map((node) => [node.id, node]))

  const folderPath: FolderPathBreadcrumbItem[] = []
  let nodeId: string | null = currentFolderId

  while (nodeId) {
    const node = nodesById.get(nodeId)
    if (!node) {
      break
    }
    folderPath.unshift({ id: node.id, name: node.name })
    nodeId = node.parentId
  }

  return [...rootPath, ...folderPath]
}
